const isWebRTCSupported = () => {
    if (window.navigator.userAgent.indexOf('Edge') > -1) {
        return false;
    }

    const _navigator = navigator as any;
    return _navigator.getUserMedia ||
        _navigator.webkitGetUserMedia ||
        _navigator.mozGetUserMedia ||
        _navigator.msGetUserMedia ||
        window.RTCPeerConnection;
};

export const browserUtils = {
    isWebRTCSupported
};